<script setup>
import { computed } from 'vue'
import { useNotification } from '@kyvg/vue3-notification'
import ModalBox from './ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'
import IconCopyLink from '../icon/IconCopyLink.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const MODAL_ID = 'modal-stream-link'

const props = defineProps({
	streamId: {
		type: String,
	},
	modalSize: {
		type: String,
		default: 'md',
		validator(v) {
			return ['xl', 'lg', 'md', 'sm'].some((size) => size === v)
		},
	},
})

const { notify } = useNotification()

const link = computed(() => `${location.origin}/app/invite-link/${props.streamId}`)

const { isVisible, hide } = useLegacyModalBridge(MODAL_ID)

const copyToClipboard = () => {
	navigator.clipboard.writeText(link.value)
	notify({ group: 'info', text: 'Copied to clipboard' })
}

const dismiss = () => {
	hide()
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		:size="modalSize"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none lg:max-w-xl"
		@close="dismiss"
	>
		<div class="px-6 py-6">
			<div class="flex justify-between gap-2">
				<input
					class="w-full h-8 rounded-lg bg-surface-4 cursor-not-allowed placeholder:text-[14px] pl-2 text-sm"
					type="text"
					disabled
					:value="link"
				>
				<FormButton @click="copyToClipboard" class="shrink-0">
					<IconCopyLink />
				</FormButton>
			</div>
		</div>
	</ModalBox>
</template>
